import InstructorsTable from "./InstructorsTable";
export default InstructorsTable;
